import { AnyProjectUser, ProjectGroup, projectUsers } from 'admin-web-utils'
import React from 'react'
import { Navigate } from 'react-router'
import { FeatureFlag } from '../../feature-flags'
import * as Pages from '../../pages'
import { NewRouteDefinition } from '../../routes'

export const getServiceRoutes = (): NewRouteDefinition[] => [
  userServiceRoutes(),
  sudoServiceRoutes(),
  vaultServiceRoutes(),
  voiceCallingServiceRoutes(),
  emailServiceRoutes(),
]

const vaultServiceRoutes = (): NewRouteDefinition => ({
  path: 'vaults',
  displayName: 'Vaults',
  iconPath: '/images/vault.svg',
  usage: 'sidebar',
  requiredAuth: [
    ProjectGroup.Admin,
    ProjectGroup.L2Support,
    ProjectGroup.Support,
  ],
  element: <Navigate to="vault-management" />,
  featureFlag: FeatureFlag.SUPPORT_TOOLS,
  requiredService: {
    serviceId: 'secure-vault-service',
  },
  routes: [
    {
      path: 'vaults/vault-management',
      element: <Pages.VaultManagement />,
      featureFlag: FeatureFlag.SUPPORT_TOOLS,
      displayName: 'Vault Management',
      usage: 'sidebar',
    },
  ],
})

export const userServiceRoutes = (): NewRouteDefinition => ({
  path: 'users',
  displayName: 'Users',
  iconPath: '/images/user.png',
  usage: 'sidebar',
  requiredAuth: AnyProjectUser,
  element: <Navigate to="dashboard" />,
  featureFlag: FeatureFlag.USER_DASHBOARD,
  routes: [
    {
      path: 'users/dashboard',
      element: <Pages.UsersDashboard />,
      featureFlag: FeatureFlag.USER_DASHBOARD,
      displayName: 'Dashboard',
      usage: 'sidebar',
    },
    {
      path: 'users/registration-support',
      element: <Pages.RegistrationSupport />,
      featureFlag: FeatureFlag.USER_DASHBOARD,
      displayName: 'Registrations Support',
      usage: 'sidebar',
      requiredAuth: projectUsers(ProjectGroup.Developer, ProjectGroup.Support),
    },
  ],
})

const sudoServiceRoutes = (): NewRouteDefinition => ({
  path: 'sudos',
  displayName: 'Sudos',
  iconPath: '/images/sudos.png',
  usage: 'sidebar',
  element: <Navigate to="dashboard" />,
  featureFlag: FeatureFlag.SUDO_DASHBOARD,
  requiredAuth: projectUsers(ProjectGroup.Developer),
  requiredService: {
    serviceId: 'sudo-service',
    teaserComponent: <Pages.SudosTeaser />,
  },
  routes: [
    {
      path: 'sudos/dashboard',
      element: <Pages.SudosDashboard />,
      featureFlag: FeatureFlag.SUDO_DASHBOARD,
      displayName: 'Dashboard',
      usage: 'sidebar',
    },
  ],
})

const voiceCallingServiceRoutes = (): NewRouteDefinition => ({
  path: 'voice-calling',
  displayName: 'Voice Calling',
  iconPath: '/images/calling.png',
  element: <Navigate to="dashboard" />,
  usage: 'sidebar',
  requiredAuth: AnyProjectUser,
  requiredService: {
    serviceId: 'voice-calling-service',
    teaserComponent: <Pages.VoiceCallingTeaser />,
  },
  routes: [
    {
      path: 'voice-calling/dashboard',
      element: <Pages.VoiceCallingDashboard />,
      displayName: 'Dashboard',
      usage: 'sidebar',
      requiredService: {
        serviceId: 'voice-calling-service',
        teaserComponent: <Pages.VoiceCallingTeaser />,
      },
    },
  ],
})

const emailServiceRoutes = (): NewRouteDefinition => ({
  path: 'encrypted-email',
  displayName: 'Email',
  iconPath: '/images/email.png',
  usage: 'sidebar',
  element: <Navigate to="dashboard" />,
  requiredAuth: projectUsers(ProjectGroup.Developer),
  routes: [
    {
      path: 'encrypted-email/dashboard',
      element: <Pages.EncryptedEmailDashboard />,
      displayName: 'Dashboard',
      usage: 'sidebar',
    },
  ],
})
